module.exports = __webpack_public_path__ + "39e00103988ac9b90917aae6f3b2647d.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/workshop.jpg
 ** module id = 430
 ** module chunks = 0
 **/